import { render, staticRenderFns } from "./RoundingPrices.vue?vue&type=template&id=3d807c63&scoped=true"
import script from "./RoundingPrices.vue?vue&type=script&lang=ts"
export * from "./RoundingPrices.vue?vue&type=script&lang=ts"
import style0 from "./RoundingPrices.vue?vue&type=style&index=0&id=3d807c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d807c63",
  null
  
)

export default component.exports